import * as React from 'react';
import Box from '@mui/material/Box';
import { Tooltip, Typography } from '@mui/material';


type Props = {
  gwpsf: number
  horizontal: boolean
}

export default function UIWallTypeGwp ({gwpsf, horizontal}: Props) {
  const toolTipText = horizontal ?
    'Global Warming Potential (GWP) per horizontal square foot of assembly.' :
    'Global Warming Potential (GWP) per square foot of wall area.'
  return(
    <Box>
      <Tooltip title={toolTipText} placement='top' arrow>
        <Typography variant='h3' paddingLeft={1}>{gwpsf.toFixed(2)}</Typography>
      </Tooltip>
      <Typography variant='h6' paddingLeft={1} color='textSecondary'>kgCO2e/sf</Typography>
    </Box>
  )

}